import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../../../global-config'
import { productIsBelgian1P } from '../../../../product'
import { productSearchAlgoliaAccessorGetOffersData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetOffersData'
import { productSearchAlgoliaAccessorGetPricingData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetPricingData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

type ProductSearchResultItemPriceContainerListPriceProps = {
  showDiscount: boolean
}
export const ProductSearchResultItemPriceContainerListPrice: FC<
  ProductSearchResultItemPriceContainerListPriceProps
> = ({ showDiscount }) => {
  const { tenant } = useGlobalConfigContext()

  const { algoliaRecord, isMarketplace } = useProductSearchResultItemContext()
  const { bestOffer, isSaeOffer } = productSearchAlgoliaAccessorGetOffersData(
    algoliaRecord,
    isMarketplace,
  )

  const { isListPricePresent, isPriceStrikedThrough, listPriceFormatted } =
    productSearchAlgoliaAccessorGetPricingData(algoliaRecord)

  const listPriceFormattedToShow = isSaeOffer
    ? listPriceFormatted
    : bestOffer?.strike_price?.formatted

  const isBelgian1P = productIsBelgian1P(tenant, algoliaRecord)
  const shouldVisuallyStrikeThroughPrice = isPriceStrikedThrough && !isBelgian1P

  const listPriceLabel = isSaeOffer ? (
    <FormattedMessage id="general.label.listPrice" />
  ) : (
    <FormattedMessage id="general.label.miraklListPrice" />
  )

  return isListPricePresent && listPriceFormattedToShow && showDiscount ? (
    <div className="text-dark-primary-max">
      <span className="mr-1">{listPriceLabel}</span>
      <span
        className={clsx(shouldVisuallyStrikeThroughPrice && 'line-through')}
      >
        {listPriceFormattedToShow}
      </span>
    </div>
  ) : null
}
